import { PopupType } from '../../../components/popup/types';
import { popupActions } from '../../../store/slices/popup/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface CustomServerMessage extends GameCommunicationMessageType {
  value?: string;
}

export class CoreMessageGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Message;

  public process(message: CustomServerMessage): void {
    if (message.value) {
      const data = JSON.parse(message.value)[0];

      this.store.dispatch(popupActions.setCustomPopup(data));
      this.store.dispatch(popupActions.pushPopup(PopupType.CustomPopup));
    }
  }
}
